import React from "react";
import { Layout, Steps, Row, Col } from "antd";
import logo from "../../images/mc-logo-full.png";
import {selectYourPlanTitle, steps } from "../../utils/steps";
import { useAppContext } from "../../context/AppContext";
import { navigate } from "@reach/router";
import styles from "./step.module.less";
import { TRANSACTIONAL_API } from "../../utils/constants";
import { useConfigContext } from "../../context/ConfigContext";

const { Header, Content } = Layout;
const { Step } = Steps;

const getStepsWithEmailApiPlanUrl = (productHandles, emailApiPricingPlansWebsiteUrl) => {
    if (
        productHandles.length === 1 &&
        productHandles[0] === TRANSACTIONAL_API
    ) {
        return steps.map(item =>
            item.title === selectYourPlanTitle
                ? { ...item, url: emailApiPricingPlansWebsiteUrl }
                : item
        );
    }
    return steps;
};

const StepLayout = props => {
    const {
        state: { step , cart },
    } = useAppContext();
    const {
        config: {
            emailApiPricingPlansWebsiteUrl
        }
    } = useConfigContext();

    const { items = []} = cart || {};
    const productHandles = items.map(item => item.productHandle);
    const stepsWithUpdatedEmailApiUrl = getStepsWithEmailApiPlanUrl(productHandles, emailApiPricingPlansWebsiteUrl);

    return (
        <Layout
            style={{
                overflowX: "hidden",
                position: "relative",
                margin: "0 auto",
            }}
        >
            <Header
                style={{
                    background: "#fff",
                    position: "relative",
                    height: "100%",
                    padding: "0",
                }}
            >
                <Row
                    type="flex"
                    justify="space-around"
                    align="middle"
                    style={{ boxShadow: "0 1px 0 rgba(0,0,0,0.08)", padding: "1rem 3rem" }}
                >
                    <Col xs={24} lg={6} style={{ marginTop: "-1rem" }}>
                        <span className={styles.mcLogoLink}>
                            <img alt="MailChannels" className={styles.mcLogo} src={logo} />
                        </span>
                    </Col>
                    <Col xs={0} lg={18}>
                        <div className="steps" style={{ maxWidth: "960px", minWidth: "500px" }}>
                            <Steps
                                current={step}
                                onChange={stepIndex => {
                                    //make steps that are waiting to be done unclickable
                                    if (stepIndex > step) return false;
                                    navigate(stepsWithUpdatedEmailApiUrl[stepIndex].url);
                                }}
                            >
                                {stepsWithUpdatedEmailApiUrl.map((item, key) => (
                                    <Step
                                        title={item.title}
                                        key={key}
                                        //make steps that are waiting to be done unclickable
                                        style={
                                            step < parseInt(key) ? { pointerEvents: "none" } : {}
                                        }
                                    />
                                ))}
                            </Steps>
                        </div>
                    </Col>
                </Row>
            </Header>
            <Content style={{ minHeight: "400px", background: "#fff" }}>{props.children}</Content>
        </Layout>
    );
};

export default StepLayout;
